import { Box } from '@mui/material';
import MessageSection from './message_section';
import TextFieldSection from './text_field_section';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { createWaterCoolerConversationThunk, fetchWaterCoolerThunk } from '../../redux/thunks/watercooler';
import { useDispatch, useSelector } from 'react-redux';

const WaterCoolerComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { conversations, loaders } = useSelector((state: RootState) => state.watercooler);
    const sortedConversations = [...conversations].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

    useEffect(() => {
        const fetchWaterCoolerDetails = async () => {
            try {
                await dispatch(fetchWaterCoolerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            } catch (e) {
                // Catch errors
            }
        };

        fetchWaterCoolerDetails();
    }, []);

    const createMessage = async (message: string, base64: string | null) => {
        try {
            await dispatch(createWaterCoolerConversationThunk({ message, file: base64 || '', client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
        } catch (e) {
            // Catch errors
        }
    };

    return <Box>
        <MessageSection conversations={sortedConversations} loaders={loaders.isLoading} />
        <TextFieldSection createMessageHandler={createMessage} loaders={loaders.isCreating || loaders.isLoading} />
    </Box>;
};

export default WaterCoolerComponent;